import { LogD } from "../../../function/LogLapper";
import dayjs from 'dayjs';
import { SpeedKind, MeasureLowKind, MeasureHighKind } from '../../../Constant';

export type SelectDataType = {
  devid: number;
  xid: number;
  yid: number;
  fromDay: Date;
  toDay: Date;
}

export type MeasureInfoType = {
  AiCard: number;
  AiCh: number;
  DevIndex: number;
  DevName: string;
  DevNo: string;
  EntryNo: number;
  ItemName: string;
  ItemNameNo: number;
  KindNo: number;
  LogStart: string;
  MesName: string;
  PlcNo: number;
  Unit: string;

  SetNo: number;
  Speed: number;
  selectDay: string;
  selectTime: string;
  name: string;
  id: number;
};

export type GraphDataType = {
  RegressionValue: number;
  XValue: number;
  YValue: number;
  ValueColDate: string;
};

export type GraphDataInfoType = {
  GraphDatas: Array<GraphDataType>
};

export type XYSymbolSettingModel = {
  /**記号 */
  SymbolName: string;
  /**設定開始日 */
  fromDate: string;
  /**設定終了日 */
  toDate: string;
};
export type XYColorSettinModel = {
  /**カラーパレット選択 */
  ColorPalette: number;
  /**散布図のカラー */
  ScatterColor: string;
  /**開始月 */
  StartMonth: number | null;
  /**終了月 */
  EndMonth: number | null;
  /**色のグループNo */
  ColorGroupNo: number;
  /**月設定 設定開始日 */
  MonthFromDate: string;
  /**月設定 設定終了日 */
  MonthToDate: string;
}

export type XYDiagramDateSettingModel = {
  GraphDatas: Array<GraphDataType>;
  YearDateSetting: XYSymbolSettingModel;
  ColorDataSetting: XYColorSettinModel;
}

export type XYDiagramSettingModel = {
  GraphDataItems: Array<XYDiagramDateSettingModel>;
  YearFlg: number;
  MonthFlg: number;
};


/**
 * 温度のデータかどうかを返す
 * @param target 判定対象データ
 * @returns
 */
export const IsTemperatureItem = (target?: MeasureInfoType): boolean => {
  if (target != null) {
    if (target.Speed == 1 && target.KindNo == 3) {
      return true;
    }
  }
  return false;
}

/**
 * デバイス情報を取得
 * @returns 
 */
export const GetMeasureInfoType = (): Promise<MeasureInfoType[]> => {
  return new Promise((resolve, reject) => {
    fetch("api/MeasuleInfo")
      .then((res) => res.json())
      .then((result: MeasureInfoType[]) => {
        console.debug(result);
        if (MeasureInfoTypeListValidate(result)) resolve(result);
        reject('Invalidate response');
      },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
  });
};

const MeasureInfoTypeListValidate = (data: MeasureInfoType[]) => {
  LogD(`MeasureInfoTypeTypeListValidate ckeck ${data}`, true);
  if (data == undefined) return false;
  LogD("MeasureInfoTypeTypeListValidate ckeck ok", true);
  return true;
};

/**
 * X-Y分布図　年設定/月設定のグラフデータ取得
 * @param groupNo 
 * @param xPlcNo 
 * @param xSetNo 
 * @param xSpeed 
 * @param xKindNo 
 * @param yPlcNo 
 * @param ySetNo 
 * @param ySpeed 
 * @param yKindNo 
 * @returns 
 */
export const GetXYDiagramData = (groupNo: number, xPlcNo: number, xSetNo: number, xSpeed: number, xKindNo: number, yPlcNo: number,
  ySetNo: number, ySpeed: number, yKindNo: number, fromTime: Date, toTime: Date): Promise<XYDiagramSettingModel> => {
  const url = `api/XYDiagramModel/GetXYDiagramData`;
  var param = "";
  param += `groupNo=${groupNo}&&xPlcNo=${xPlcNo}&&xSetNo=${xSetNo}&&xSpeed=${xSpeed}&&xKindNo=${xKindNo}&&`;
  param += `yPlcNo=${yPlcNo}&&ySetNo=${ySetNo}&&ySpeed=${ySpeed}&&yKindNo=${yKindNo}&&`;
  param += `fromTime=${dayjs(fromTime).format("YYYY-MM-DD HH:mm:ss")}&&toTime=${dayjs(toTime).format("YYYY-MM-DD HH:mm:ss")}`;

  console.debug(`${url}?${param}`);

  return new Promise((resolve, reject) => {
    fetch(`${url}?${param}`)
      .then((res) => res.json())
      .then((result: XYDiagramSettingModel) => {
        console.debug(["GetXYDiagramData result", result]);
        if (XYDiagramDataModelValidate(result)) resolve(result);
        reject('Invalidate response');
      },
        (error) => {
          console.log(error);
          reject(error);
        });
  });
}

const XYDiagramDataModelValidate = (data: XYDiagramSettingModel) => {
  LogD(`XYDiagramDataModelValidate ckeck ${data}`, true);
  if (data == undefined) return false;
  LogD("XYDiagramDataModelValidate ckeck ok", true);
  return true;
};

/**
 * X-Y 分布比較として有効かをチェック
 * @param speed
 * @param measure
 * @returns
 */
export const IsValidKindOfXyCmp = (speed: number, measure: number): boolean => {
  if (speed === SpeedKind.SPEED_KIND_LOW && measure === MeasureLowKind.TEMPERATURE) {
    return true;
  }
  if (
    speed === SpeedKind.SPEED_KIND_HIGHT &&
    (measure === MeasureHighKind.R_CURRENT ||
      measure === MeasureHighKind.S_CURRENT ||
      measure === MeasureHighKind.T_CURRENT ||
      measure === MeasureHighKind.VIBRATION ||
      measure === MeasureHighKind.TEMPERATURE_IOT)
  ) {
    return true;
  }

  return false;
};
